import { v4 as uuidv4 } from 'uuid';

import { SmartcardErrorNonBlocking } from '../constants/AppConstants';
import BacsService from '../../src/services/BacsServices';

/*
    Checks for presence of any key in a given list of keys on a given object, returns
    true if any are found, false if none.
*/
const objectHasAnyKeyInList = (obj, keys) => Boolean(keys.find(key => obj.hasOwnProperty(key)));

const includesChildPreencode = (errors, numChildTickets, numChildSmartcards) =>
    errors && errors.some(err => objectHasAnyKeyInList(err, [SmartcardErrorNonBlocking.NO_SMARTCARD]))
    && (numChildTickets - numChildSmartcards === 1);

const chunk = (str, n) => {
    let ret = [];
    for (let i = 0; i < str.length; i += n) {
        ret.push(str.substr(i, n));
    }
    return ret;
};

const isValidBACS = async (sortCode, accountNumber, setDisableContinue) => {
    try {
        const res = await BacsService.validate(
            chunk(sortCode, 2).join('-'),
            accountNumber,
        );
        setDisableContinue(res);
        return res;
    } catch (e) {
        console.warn('Error validating bacs details', e);
        return false;
    }
};

const getRandomNumberInRange = (min, max) =>
    Math.floor(Math.random() * (max - min) + min);

export const toBase64Utf8 = (str) => {
    try {
        const utf8Bytes = new TextEncoder().encode(str);
        const binary = Array.from(utf8Bytes, byte => String.fromCodePoint(byte)).join('');
        return btoa(binary);
    } catch (e) {
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(str, 'utf8').toString('base64');
        }
        throw e;
    }
};

export const generateUuidV4 = () => {
    return uuidv4();
};

export default {
    getRandomNumberInRange,
    objectHasAnyKeyInList,
    includesChildPreencode,
    chunk,
    isValidBACS,
    toBase64Utf8,
    generateUuidV4,
};
